import {
  React,
  Component,
  withRouter,
  withCookies
} from 'imports/CommonImports';

import {
  NavigationCloseIcon,
} from 'imports/IconsImports';

import {
  SecondaryButtonFlat,
} from 'imports/DesignImports';

import {
  Drawer,
  AppBar,
  IconButton,
} from 'material-ui';


const styles = {
  chatWindow:{
    position:'relative'
  },
  header: {
    backgroundColor: 'rgb(33, 47, 85)'
  },
  commentsContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '20px'
  },
  messages: {
    margin: '10px',
    overflowY: 'scroll',
    maxHeight: '70%'
  },
  text: {
    margin: '10px',
    position: 'absolute',
    bottom: 0
  },
  textArea: {
    width: '320px'
  },
  chip:{
    margin: '5px'
  },
  message: {
    overflow:'hidden',
    lineHeight: '110%',
    marginTop: '0px',
    marginBottom: '5px',
    whiteSpace: 'pre-line'
  },
  timestamp:{
    marginBottom: '0px',
    fontStyle: 'italic',
    fontSize: 'smaller'
  }
}

class Appointment extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleToggle = () => this.setState({open: !this.state.open});

  handleClose = () => this.setState({open: false});

  componentDidMount(){
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js');
    document.body.appendChild(script);

    const div = document.createElement('div');
    div.setAttribute('class', 'calendly-inline-widget');
    div.setAttribute('data-url', 'https://calendly.com/indicei3-innspiral/60min');
    div.setAttribute('style', 'min-width:320px;height:580px;');
    document.getElementById('calendly').appendChild(div);
  }

  render() {
    return (
      <div>
        <div style={styles.commentsContainer}>
        <SecondaryButtonFlat label="¿Necesitas Ayuda?" onClick={this.handleToggle} />
        </div>
        <Drawer
          docked={false}
          width={400}
          openSecondary={true}
          open={this.state.open}
          onRequestChange={(open) => this.setState({open})}
          style={{...styles.chatWindow}}
        >
          <AppBar
            style={{...styles.header}}
            title="Agendar hora"
            iconElementLeft={<div></div>}
            iconElementRight={<IconButton onClick={this.handleClose}><NavigationCloseIcon /></IconButton>}
          />
          <div id="calendly">
          </div>
        </Drawer>
      </div>
    );
  }

}

export default withCookies(withRouter(Appointment));



// WEBPACK FOOTER //
// ./src/components/files/Appointment.js